<!-- Generic Data Table -->
<div class="data-table-section">
  @if (config.showCard) {
  <mat-card [class]="title?'data-table-card':''" [ngClass]="config.cardClass">
    @if (title && config.showHeader) {
    <mat-card-header>
      <mat-card-title>{{ title }}</mat-card-title>
      @if (subtitle) {
      <mat-card-subtitle>{{ subtitle }}</mat-card-subtitle>
      }
    </mat-card-header>
    }
    <mat-card-content [class.p-a-0]="!title">
      <div class="table-container">
        <table class="data-table" [ngClass]="config.tableClass">
          <thead>
            <tr>
              @for (column of columns; track trackColumn($index, column)) {
              <th
                [ngClass]="getHeaderClasses(column)"
                [style.text-align]="getColumnAlignment(column)"
                [style.width]="getColumnWidth(column)"
                (click)="onSort(column)">
                @if (column.tooltip) {
                <span [matTooltip]="column.tooltip">{{ column.label }}</span>
                } @else {
                {{ column.label }}
                }
                @if (column.sortable && config.enableSorting) {
                <span class="sort-indicator">
                  @if (sortColumn === column.key) {
                    @if (sortDirection === 'asc') {
                      ↑
                    } @else {
                      ↓
                    }
                  } @else {
                    ↕
                  }
                </span>
                }
              </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of data; track trackRow(i, row); let i = $index) {
            <tr
              [ngClass]="getRowClasses(i)"
              (click)="onRowClick(row)">
              @for (column of columns; track trackColumn($index, column)) {
              <td
                [ngClass]="getCellClasses(column)"
                [style.text-align]="getColumnAlignment(column)"
                [style.width]="getColumnWidth(column)">
                <div class="cell-content">
                  @if ((column.key === 'source' || column.key === 'url') && getDomainForIcon(row, column.key)) {
                    <div class="cell-with-icon">
                      <img [src]="getFaviconUrl(getDomainForIcon(row, column.key))" alt="" class="cell-favicon" (error)="onFaviconError($event)" />
                      @if (column.key === 'url' && row['urlClickable']) {
                        <div class="url-cell">
                          @if (row['query']) {
                            <a [href]="getSearchUrlForQuery(row['query'])" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()" class="url-prompt-link">{{ row['query'] }}</a>
                          }
                          <a [href]="row['urlClickable']" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()" class="url-link" [title]="row['url'] || row['urlClickable']">{{ getTruncatedUrlDisplay(row['url'] || row['urlClickable'], 25) }}</a>
                        </div>
                      } @else {
                        <span>{{ formatCellValue(row[column.key], column) }}</span>
                      }
                    </div>
                  } @else if (column.key === 'url' && row['urlClickable']) {
                    <div class="url-cell">
                      @if (row['query']) {
                        <a [href]="getSearchUrlForQuery(row['query'])" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()" class="url-prompt-link">{{ row['query'] }}</a>
                      }
                      <a [href]="row['urlClickable']" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()" class="url-link" [title]="row['url'] || row['urlClickable']">{{ getTruncatedUrlDisplay(row['url'] || row['urlClickable'], 25) }}</a>
                    </div>
                  } @else if (column.key === 'url_type') {
                    <span [class]="'chip chip-url-type-' + getUrlTypeChipClass(row)">{{ formatCellValue(row[column.key], column) }}</span>
                  } @else if (column.key === 'domain_type') {
                    <span [class]="'chip chip-domain-type-' + getDomainTypeChipClass(row)">{{ formatCellValue(row[column.key], column) }}</span>
                  } @else if (column.key === 'brand_mentioned') {
                    <span [class]="'chip chip-' + getBrandMentionedChipClass(row)">{{ formatCellValue(row[column.key], column) }}</span>
                  } @else if (column.key === 'mentioned_brands' && (row['cited_domains_list']?.length || row['mentioned_brands_list']?.length)) {
                    <div class="mention-chips">
                      @if (row['cited_domains_list']?.length) {
                        @for (dom of row['cited_domains_list']; track dom) {
                          <img [src]="getFaviconUrl(dom)" alt="" class="mention-domain-favicon" [title]="dom" (error)="onFaviconError($event)" />
                        }
                      }
                      @for (brandName of row['mentioned_brands_list'] || []; track brandName) {
                      <span class="mention-chip" [title]="brandName">
                        <span class="mention-chip-initial">{{ getBrandInitial(brandName) }}</span>
                        <span class="mention-chip-name">{{ brandName }}</span>
                      </span>
                      }
                    </div>
                  } @else if (column.key === 'mentioned_brands') {
                    {{ formatCellValue(row[column.key], column) }}
                  } @else {
                    {{ formatCellValue(row[column.key], column) }}
                  }
                </div>
              </td>
              }
            </tr>
            }
          </tbody>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
  } @else {
  <div class="table-container">
    <table class="data-table" [ngClass]="config.tableClass">
      <thead>
        <tr>
          @for (column of columns; track trackColumn($index, column)) {
          <th
            [ngClass]="getHeaderClasses(column)"
            [style.text-align]="getColumnAlignment(column)"
            [style.width]="getColumnWidth(column)"
            (click)="onSort(column)">
            @if (column.tooltip) {
            <span [matTooltip]="column.tooltip">{{ column.label }}</span>
            } @else {
            {{ column.label }}
            }
            @if (column.sortable && config.enableSorting) {
            <span class="sort-indicator">
              @if (sortColumn === column.key) {
                @if (sortDirection === 'asc') {
                  ↑
                } @else {
                  ↓
                }
              } @else {
                ↕
              }
            </span>
            }
          </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of data; track trackRow(i, row); let i = $index) {
        <tr
          [ngClass]="getRowClasses(i)"
          (click)="onRowClick(row)">
          @for (column of columns; track trackColumn($index, column)) {
          <td
            [ngClass]="getCellClasses(column)"
            [style.text-align]="getColumnAlignment(column)"
            [style.width]="getColumnWidth(column)">
            <div class="cell-content">
              @if ((column.key === 'source' || column.key === 'url') && getDomainForIcon(row, column.key)) {
                <div class="cell-with-icon">
                  <img [src]="getFaviconUrl(getDomainForIcon(row, column.key))" alt="" class="cell-favicon" (error)="onFaviconError($event)" />
                  @if (column.key === 'url' && row['urlClickable']) {
                    <div class="url-cell">
                      @if (row['query']) {
                        <a [href]="getSearchUrlForQuery(row['query'])" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()" class="url-prompt-link">{{ row['query'] }}</a>
                      }
                      <a [href]="row['urlClickable']" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()" class="url-link" [title]="row['url'] || row['urlClickable']">{{ getTruncatedUrlDisplay(row['url'] || row['urlClickable'], 25) }}</a>
                    </div>
                  } @else {
                    <span>{{ formatCellValue(row[column.key], column) }}</span>
                  }
                </div>
              } @else if (column.key === 'url' && row['urlClickable']) {
                <div class="url-cell">
                  @if (row['query']) {
                    <a [href]="getSearchUrlForQuery(row['query'])" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()" class="url-prompt-link">{{ row['query'] }}</a>
                  }
                  <a [href]="row['urlClickable']" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()" class="url-link" [title]="row['url'] || row['urlClickable']">{{ getTruncatedUrlDisplay(row['url'] || row['urlClickable'], 25) }}</a>
                </div>
              } @else if (column.key === 'url_type') {
                <span [class]="'chip chip-url-type-' + getUrlTypeChipClass(row)">{{ formatCellValue(row[column.key], column) }}</span>
              } @else if (column.key === 'domain_type') {
                <span [class]="'chip chip-domain-type-' + getDomainTypeChipClass(row)">{{ formatCellValue(row[column.key], column) }}</span>
              } @else if (column.key === 'brand_mentioned') {
                <span [class]="'chip chip-' + getBrandMentionedChipClass(row)">{{ formatCellValue(row[column.key], column) }}</span>
              } @else if (column.key === 'mentioned_brands' && (row['cited_domains_list']?.length || row['mentioned_brands_list']?.length)) {
                <div class="mention-chips">
                  @if (row['cited_domains_list']?.length) {
                    @for (dom of row['cited_domains_list']; track dom) {
                      <img [src]="getFaviconUrl(dom)" alt="" class="mention-domain-favicon" [title]="dom" (error)="onFaviconError($event)" />
                    }
                  }
                  @for (brandName of row['mentioned_brands_list'] || []; track brandName) {
                  <span class="mention-chip" [title]="brandName">
                    <span class="mention-chip-initial">{{ getBrandInitial(brandName) }}</span>
                    <span class="mention-chip-name">{{ brandName }}</span>
                  </span>
                  }
                </div>
              } @else if (column.key === 'mentioned_brands') {
                {{ formatCellValue(row[column.key], column) }}
              } @else {
                {{ formatCellValue(row[column.key], column) }}
              }
            </div>
          </td>
          }
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</div>
